// extracted by mini-css-extract-plugin
export default {"input":"MadLibInputs-styles__input__knlgt","colorPicker":"MadLibInputs-styles__colorPicker__BSz1c","helpText":"MadLibInputs-styles__helpText__uNB7T"};